import { InternalScenarios } from "@regulaforensics/vp-frontend-document-components";

export const REGULA_SCENARIO = InternalScenarios.Locate;

export const MAX_UPLOAD_RETRIES = 3;
